import { rest } from 'msw';

import {
    ConditionEvent,
    ConditionExceptionStatus,
    LoanRoleAssignment,
    LoanStatusNonDelegated,
    NotificationFrequency,
    NotificationMethod,
    NotificationType
} from '../..';
import { getMockUrl } from '../../../mocks/getMockUrl';

import { NotificationConfig } from './notifications-api';


export const mocks = [
    // Get notifications
    rest.get(getMockUrl('/auth/role/:roleID/notifications'), (req, res, ctx) => (res(
        ctx.status(200),
        ctx.json(notifications)
    ))),
    rest.get(getMockUrl('/client/role/:roleID/notifications'), (req, res, ctx) => (res(
        ctx.status(200),
        ctx.json(notifications)
    ))),
    rest.get(getMockUrl('/customer/:customerID/role/:roleID/notifications'), (req, res, ctx) => (res(
        ctx.status(200),
        ctx.json(notifications)
    ))),

    // Add notification
    rest.post(getMockUrl('/auth/role/:roleID/notifications'), (req, res, ctx) => (res(
        ctx.status(200),
        ctx.json({
            ...req.body as NotificationConfig,
            id: notificationId++
        })
    ))),
    rest.post(getMockUrl('/client/role/:roleID/notifications'), (req, res, ctx) => (res(
        ctx.status(200),
        ctx.json({
            ...req.body as NotificationConfig,
            id: notificationId++
        })
    ))),
    rest.post(getMockUrl('/customer/:customerID/role/:roleID/notifications'), (req, res, ctx) => (res(
        ctx.status(200),
        ctx.json({
            ...req.body as NotificationConfig,
            id: notificationId++
        })
    ))),

    // Edit notification
    rest.put(getMockUrl('/auth/role/:roleID/notifications/:notificationID'), (req, res, ctx) => (res(
        ctx.status(200),
        ctx.json(req.body)
    ))),
    rest.put(getMockUrl('/client/role/:roleID/notifications/:notificationID'), (req, res, ctx) => (res(
        ctx.status(200),
        ctx.json(req.body)
    ))),
    rest.put(getMockUrl('/customer/:customerID/role/:roleID/notifications/:notificationID'), (req, res, ctx) => (res(
        ctx.status(200),
        ctx.json(req.body)
    ))),

    // Delete notification
    rest.delete(getMockUrl('/auth/role/:roleID/notifications/:notificationID'), (req, res, ctx) => (res(
        ctx.status(200)
    ))),
    rest.delete(getMockUrl('/client/role/:roleID/notifications/:notificationID'), (req, res, ctx) => (res(
        ctx.status(200)
    ))),
    rest.delete(getMockUrl('/customer/:customerID/role/:roleID/notifications/:notificationID'), (req, res, ctx) => (res(
        ctx.status(200)
    )))
];

// Get subscribed notifications for Client Underwriter role
let notificationId = 1;
const notifications: NotificationConfig[] = [
    {
        id: notificationId++,
        roleId: 6,
        type: NotificationType.LOAN_STATUS_NON_DELEGATED,
        parameters: [ LoanStatusNonDelegated.IN_UNDERWRITING ],
        methods: [ NotificationMethod.EMAIL ],
        frequency: NotificationFrequency.DAILY,
        includeUnassigned: false
    },
    {
        id: notificationId++,
        roleId: 6,
        type: NotificationType.CONDITION_EVENT,
        parameters: [ ConditionEvent.RECEIVED ],
        methods: [ NotificationMethod.IN_APP, NotificationMethod.EMAIL ],
        frequency: NotificationFrequency.IMMEDIATELY,
        includeUnassigned: true
    },
    {
        id: notificationId++,
        roleId: 6,
        type: NotificationType.CONDITION_EXCEPTION_STATUS,
        parameters: [ ConditionExceptionStatus.APPROVED_BY_INVESTOR ],
        methods: [ NotificationMethod.IN_APP ],
        frequency: NotificationFrequency.WEEKLY,
        includeUnassigned: true
    },
    {
        id: notificationId++,
        roleId: 6,
        type: NotificationType.LOAN_ROLE_ASSIGNMENT,
        parameters: [ LoanRoleAssignment.UNDERWRITER ],
        methods: [],
        frequency: NotificationFrequency.IMMEDIATELY,
        includeUnassigned: true
    },
    {
        id: notificationId++,
        roleId: 8,
        type: NotificationType.LOAN_STATUS_NON_DELEGATED,
        parameters: [
            LoanStatusNonDelegated.IN_UNDERWRITING,
            LoanStatusNonDelegated.LOAN_SETUP
        ],
        methods: [ NotificationMethod.EMAIL ],
        frequency: NotificationFrequency.WEEKLY,
        includeUnassigned: false
    },
    {
        id: notificationId++,
        roleId: 8,
        type: NotificationType.LOAN_ROLE_ASSIGNMENT,
        parameters: [
            LoanRoleAssignment.LOAN_SETUP,
            LoanRoleAssignment.UNDERWRITER
        ],
        methods: [ NotificationMethod.EMAIL, NotificationMethod.IN_APP ],
        frequency: NotificationFrequency.DAILY,
        includeUnassigned: true
    }
];
